import React from 'react';

import SvgIcon from '@mui/material/SvgIcon';
import { ListItem } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';

import CheckAccess from 'common/components/CheckAccess';

import StyledListItemButton from './StyledComponents/StyledListItemButton';
import StyledListItemText from './StyledComponents/StyledListItemTextOption';

const MenuOption = ({
    Icon,
    disabled,
    drawerSize,
    handleDrawerToggle,
    id,
    listItemClassName,
    mobileOpen,
    onClick,
    requiredPermissions,
    selected,
    setOpenDrawer,
    size = 'normal',
    title,
    to,
    upgradeIcon,
}) => {
    const handleOnClick = (event) => {
        if (onClick) {
            onClick(event);
            return;
        }
        if (mobileOpen && handleDrawerToggle) handleDrawerToggle();
        if (setOpenDrawer) setOpenDrawer(false);
    };

    return (
        <CheckAccess requiredPermissions={requiredPermissions}>
            <ListItem className={listItemClassName} disablePadding>
                <StyledListItemButton
                    component={RouterLink}
                    disabled={disabled}
                    drawersize={drawerSize}
                    id={id || `sidebar-${to.substring(1)}`}
                    onClick={handleOnClick}
                    selected={selected}
                    to={to}
                >
                    {Icon && (
                        <SvgIcon>
                            <Icon />
                        </SvgIcon>
                    )}
                    <StyledListItemText primary={title} size={size} />
                    {upgradeIcon}
                </StyledListItemButton>
            </ListItem>
        </CheckAccess>
    );
};

MenuOption.propTypes = {
    disabled: PropTypes.bool,
    drawerSize: PropTypes.string,
    handleDrawerToggle: PropTypes.func,
    Icon: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    id: PropTypes.string,
    listItemClassName: PropTypes.string,
    mobileOpen: PropTypes.bool,
    onClick: PropTypes.func,
    requiredPermissions: PropTypes.array,
    selected: PropTypes.bool,
    setOpenDrawer: PropTypes.func,
    size: PropTypes.string,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    to: PropTypes.string,
    upgradeIcon: PropTypes.element,
};

export default MenuOption;
